import { render, staticRenderFns } from "./DisplayPlatform.vue?vue&type=template&id=c6dd101c&scoped=true"
import script from "./DisplayPlatform.vue?vue&type=script&lang=js"
export * from "./DisplayPlatform.vue?vue&type=script&lang=js"
import style0 from "./DisplayPlatform.vue?vue&type=style&index=0&id=c6dd101c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dd101c",
  null
  
)

export default component.exports